import {useGetFavoriteDoctorsQuery} from 'presentation/modules/booking/favoriteDoctors/queries/useGetFavoriteDoctorsQuery';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const useFavoriteDoctorsData = () => {
	const {data: doctors, isLoading, isError, refetch} = useGetFavoriteDoctorsQuery();
	const bookingTheme = useBookingTheme({flowType: FlowEnum.HEALTH});

	return {doctors, isLoading, isError, refetch, bookingTheme};
};

export {useFavoriteDoctorsData};
